module.exports = __webpack_public_path__ + "img/product_92.ee3c99d.svg";